import React from 'react';

import PropTypes from 'prop-types';
import { MdTrackChanges } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { openApproveAdvancements } from '../../duck';

function ApproveAdvancementsAction({
  className,
  children,
  onOpenApproveAdvancements,
}) {
  return (
    <div className={className} onClick={onOpenApproveAdvancements}>
      {children || (
        <React.Fragment>
          <MdTrackChanges />
          <FormattedMessage
            id="progress.ApproveAdvancementsButton.title"
            values={{ count: 1 }}
          />
        </React.Fragment>
      )}
    </div>
  );
}

ApproveAdvancementsAction.propTypes = {
  // provided by parent
  className: PropTypes.string,
  children: PropTypes.node,
  personsAdvancements: PropTypes.array.isRequired,
  // provided by component itself
  onOpenApproveAdvancements: PropTypes.func.isRequired,
};

const mapDispatch = (dispatch, { personsAdvancements }) => ({
  onOpenApproveAdvancements: () =>
    dispatch(openApproveAdvancements(personsAdvancements)),
});

export default connect(null, mapDispatch)(ApproveAdvancementsAction);
